export const projectReportColumns = [
  {
    field: 'employeeName',
    headerName: 'Employee Name',
    flex: 1,
    minWidth: 160,
    filterable: false,
    sortable: true,
  },
  {
    field: 'employeeCode',
    headerName: 'Employee Code',
    flex: 0.7,
    minWidth: 120,
    filterable: false,
    sortable: true,
  },
  {
    field: 'projectName',
    headerName: 'Project Name',
    flex: 1,
    minWidth: 160,
    filterable: false,
    sortable: true,
  },
  {
    field: 'isManager',
    headerName: 'Is Manager',
    flex: 0.6,
    minWidth: 100,
    filterable: false,
    sortable: false,
  },
  {
    field: 'numberOfManagers',
    headerName: 'Number Of Managers',
    flex: 0.8,
    minWidth: 140,
    filterable: false,
    sortable: false,
  },
  {
    field: 'managerNames',
    headerName: 'Manager Names',
    flex: 1.4,
    minWidth: 200,
    filterable: false,
    sortable: false,
  },
];
